<div class="background">
  <div class="container surface-card shadow-6 border-round">
    <div class="p-4 w-full">
      <div class="mb-5">
        <div class="flex justify-content-between mb-3">
          <div class="text-900 text-3xl font-medium inline-block">
            <span style="line-height: 100px">Start your FREE trial</span>&nbsp;&nbsp;
          </div>
          <img alt="Image" height="100" src="assets/godh_logo_transparency.png">
        </div>
        <span class="text-600 font-medium line-height-3">Ready to find out how Global Office Data Hub can help you? Fill out the form below to access to our demo and try our solution FREE.</span>
      </div>

      <div class="grid">
        <div class="col w-6 pr-1 mr-3">
          <div [problem-details]="problemDetails" [problemDetailsKey]="'accountInformation.username'">
            <label class="block text-900 font-medium mb-1 mt-3" for="email">Business Email *</label>
            <input [(ngModel)]="email" class="w-full " id="email" (keyup.enter)="register()"
                   pInputText [validation]="emailValid" [hoverElement]="emailHover"
                   type="text">
            <div #emailHover>
              <app-validation-entry [valid]="emailValid" validText="Email is valid"
                                    errorText="Not a valid email address"></app-validation-entry>
            </div>
          </div>
        </div>
        <div class="col w-6 pr-1 mr-3">
          <div [problem-details]="problemDetails" [problemDetailsKey]="'companyInformation.companyName'">
            <label class="block text-900 font-medium mb-1 mt-3" for="companyName">Company Name *</label>
            <input [(ngModel)]="companyName" class="w-full " id="companyName" (keyup.enter)="register()"
                   pInputText [validation]="companyNameValid" [hoverElement]="companyNameHover"
                   type="text">
            <div #companyNameHover>
              <app-validation-entry [valid]="companyNameValid" validText="Company Name Required"
                                    [sameText]="true"></app-validation-entry>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col w-6 pr-1 mr-3">
          <div [problem-details]="problemDetails" [problemDetailsKey]="'accountInformation.firstName'">
            <label class="block text-900 font-medium mb-1 mt-3" for="firstName">First Name *</label>
            <input [(ngModel)]="firstName" class="w-full " id="firstName" (keyup.enter)="register()"
                   pInputText [validation]="firstNameValid" [hoverElement]="firstNameHover"
                   type="text">
            <div #firstNameHover>
              <app-validation-entry [valid]="firstNameValid" validText="First Name is required"
                                    [sameText]="true"></app-validation-entry>
            </div>
          </div>
        </div>
        <div class="col w-6 pr-1 mr-3">
          <div [problem-details]="problemDetails" [problemDetailsKey]="'accountInformation.lastName'">
            <label class="block text-900 font-medium mb-1 mt-3" for="lastName">Last Name *</label>
            <input [(ngModel)]="lastName" class="w-full " id="lastName" (keyup.enter)="register()"
                   pInputText [validation]="lastNameValid" [hoverElement]="lastNameHover"
                   type="text">
            <div #lastNameHover>
              <app-validation-entry [valid]="lastNameValid" validText="Last Name is required"
                                    [sameText]="true"></app-validation-entry>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col w-6 pr-1 mr-3">
          <div [problem-details]="problemDetails" [problemDetailsKey]="'accountInformation.password'">
            <label class="block text-900 font-medium mb-1 mt-3" for="password">Password *</label>
            <app-password-field [(value)]="password" class="w-full " id="password"
                                (keyboardEnter)="register()"></app-password-field>
          </div>
        </div>
        <div class="col w-6 pr-1 mr-3">
          <label class="block text-900 font-medium mb-1 mt-3" for="confirm-password">Confirm Password *</label>
          <input [(ngModel)]="confirmPassword" class="w-full " id="confirm-password" pInputText type="password"
                 (keyup.enter)="register()" [validation]="isSecondOasswordValid" [hoverElement]="secondPasswordHover">
          <div #secondPasswordHover>
            <app-validation-entry [valid]="isSecondOasswordValid" validText="Password matches"
                                  errorText="Password does not match"></app-validation-entry>
          </div>
        </div>
      </div>

      <div class="grid">
        <div class="relative col w-6 pr-1 mr-3">
          <a class="absolute bottom-0 font-medium no-underline text-yellow-600 text-right cursor-pointer" (click)="changeStateToLogin()"
             queryParamsHandling="preserve" routerLink="/login">Already have an account? Log in</a>
        </div>
        <div class="col w-6 pr-1 mr-3">
          <button (click)="register()" [disabled]="isRegisterButtonDisabled" class="w-full"
                  style="margin-top: 37px;">Sign Up
          </button>
        </div>
      </div>
      <span class="text-600 font-normal line-height-3 text-sm mt-3">Get setup and learn how to take control of your business communications and jobs.</span>

      <!--          <div [problem-details]="problemDetails" [problemDetailsKey]="'accountInformation.website'">-->
      <!--            <label class="block text-900 font-medium mb-1 mt-3" for="website">Company Website</label>-->
      <!--            <input [(ngModel)]="companyWebsite" class="w-full " id="website" (keyup.enter)="register()"-->
      <!--                   pInputText [validation]="companyWebsiteValid" [hoverElement]="websiteHover"-->
      <!--                   type="text">-->
      <!--            <div #websiteHover>-->
      <!--              <app-validation-entry [valid]="companyWebsiteValid" validText="Website valid"-->
      <!--                                    [sameText]="true"></app-validation-entry>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div [problem-details]="problemDetails" [problemDetailsKey]="'companyInformation.companyDescription'">-->
      <!--            <label class="block text-900 font-medium mb-1 mt-3" for="companyDescription">Company Description</label>-->
      <!--            <textarea [(ngModel)]="companyDescription" [rows]="10" class="w-full " (keyup.enter)="register()"-->
      <!--                      id="companyDescription" pInputTextarea style="height: 245px;"-->
      <!--            ></textarea>-->
      <!--          </div>-->
    </div>
  </div>

</div>


<p-dialog [(visible)]="isSubmitting" [modal]="true" [closable]="false">
  <p-progressSpinner></p-progressSpinner>
  <p>Please wait...</p>
</p-dialog>


